import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';


const OpinionArticles = () => {
    const [articles, setArticles] = useState([]);

    useEffect(() => {
        const fetchOpinionArticles = async (retries = 3) => {
          try {
            const response = await axios.get('/api/category/opinion?per_page=3');
            // Limit the articles to 3 even if the API returns more
            setArticles(response.data.slice(0, 3));
          } catch (error) {
            //console.error(`Error fetching latest opinion articles: ${error}`);
            if (retries > 0) {
              // wait for 2 seconds before retrying
              setTimeout(() => fetchOpinionArticles(retries - 1), 200);
            }
          }
        };

        fetchOpinionArticles();
    }, []);

    return (
        <div className="mr-4" >
        <div className="mt-1 flex items-center mb-1" >
            
 
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-[#3D7D63] mr-2"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          {/* Bar Chart - Represents Stock Market (Ascending Order) */}
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 20v-6M10 20v-12M16 20v-16" />
        
          {/* Blockchain Nodes - Represents Crypto */}
          <circle cx="4" cy="12" r="1.5" fill="currentColor" /> 
          <circle cx="10" cy="4" r="1.5" fill="currentColor" />
          <circle cx="16" cy="8" r="1.5" fill="currentColor" />

          {/* Connecting Line Moving Upwards */}
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 14L10 8L16 4" />
        </svg> 

        <h1 className=" text-sm pr-4" 
            style={{ fontFamily: 'var(--font-paragraph)' }}>

             Opinion...
        </h1>
        </div>
            {articles.map((article) => (
                <div key={article.id}>
                    <Link to={`/${article.pageUrl}`}>
                        <h2 className="mb-4 font-semibold" style={{fontFamily: 'Arial, Helvetica Neue, Helvetica, sans-serif', color: 'var(--text-color)', fontSize: '16px', lineHeight: '1.35em', fontWeight: '500'}}>{article.title}</h2>
                    </Link>
                </div>

            ))}
        </div>
    );
};

export default OpinionArticles;
